module.exports = __webpack_public_path__ + "media/images/categories/icon_cat16-8fdd25fb2211bcb8992cf4b9c7cfe140.svg";